import { Action, ActionFn, defaultActions } from '#/common/components/DataGrid';
import { User } from '#/graphql/types';

export const selectedActions: ActionFn<User>[] = [
  {
    key: 'delete-users',
    icon: 'trash',
    text: 'Delete',
  },
];

export const actions: Action<User>[] = [...defaultActions];
